module.exports = __webpack_public_path__ + "static/media/nike-oranje-fatalis-2.2f53817b.jpg";